enum Errors {
  AUTHORIZATION = 'AUTHORIZATION',
  NEWUSER = 'NEWUSER',
  NOTFOUND = 'NOTFOUND',
  EXPIRED = 'EXPIRED',
}

export default Errors;
